import { IFilterOptions } from '@quadminds/shared/commons';

export interface IGetOrdersFiltersDto extends IFilterOptions {
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
